export default __webpack_public_path__ + "static/media/gallery-wip-construction-improvements-screw-replacement_01.36af75d0.jpg";